// extracted by mini-css-extract-plugin
module.exports = {"preview":"styles_preview__3PTa0","info":"styles_info___wN4B","details":"styles_details__poNI9"};